<template>
  <div class="animated fadeIn">

      <b-form-fieldset
        description=""
        label="hObject name"
        :label-cols="2"
        :horizontal="true">
        <b-form-input type="text" v-model="newhObjectName"></b-form-input>
      </b-form-fieldset>

      <hr>

      <b-row align-h="between">
        <b-col sm="2">
          <h2>Tags</h2>
          <span class="badge" :style="tagStyle(item.color, item.text_color)" v-for="(item, index) in hObjectTags" :key="index">{{item.name}}</span>
          <!-- <b-nav vertical class="w-25">
            <b-nav-item v-for="(item, index) in hObjectTags" :key="index">{{item.name}}</b-nav-item>
          </b-nav> -->
          <!-- <nav class="nav flex-column">
            <a class="nav-link active" href="#">Active</a>
            <a class="nav-link" href="#">Link</a>
            <a class="nav-link" href="#">Link</a>
            <a class="nav-link disabled" href="#">Disabled</a>
          </nav> -->
        </b-col>

        <b-col sm="10">
          <div v-for="(item, index) in hObjectTypes" :key="index" class="card cardhObject">
            <img class="card-img-top" :src="getUrlHObjectTypeImage(item.image)" alt="Card image cap">
            <div class="card-body">
              <h5 class="card-title">{{item.name}}</h5>
              <p class="card-text">{{item.description}}</p>
              <div class="badge" :style="tagStyle(tag.color, tag.text_color)" v-for="(tag, index) in item.tags" :key="index">{{tag.name}}</div>
            </div>
            <div class="card-footer">
              <template v-if="!item.price_with_discount">
                <span class="text-muted">Price: <strong>{{item.price}}</strong><small>/month</small></span>
                <button class="btn btn-primary pull-right" v-b-tooltip.hover title="Create this hObject" @click="new_hObject(item.name, item.price)" >
                  <i class="icon-plus"> Get</i>
                </button>
              </template>
              <template v-if="item.price_with_discount">
                <span class="text-muted">Price: <strike>{{item.price}}</strike> <strong>{{item.price_with_discount}}</strong><small>/month</small> </span>
                <button class="btn btn-primary pull-right" v-b-tooltip.hover title="Create this hObject" @click="new_hObject(item.name, item.price_with_discount)" >
                  <i class="icon-plus"> Get</i>
                </button>
              </template>
            </div>
          </div>
        </b-col>
      </b-row>

  </div>
</template>

<script>

import axios from 'axios'
import ENV from 'ENV'
import { EventBus } from '@/js/EventBus.js'

export default {
  name: 'newHObject',
  components: {

  },
  data () {
    return {
      hObjectTypes: [],
      hObjectTags: [],
      newhObjectName: '',
      token: null,
      urlBackImages: `${ENV.server_back}/api/hobject_types/image/`
    }
  },
  mounted: function () {
    this.fetchHObjectTypes()
    this.fetchHObjectTags()
  },
  methods: {

    fetchHObjectTypes () {
      this.token = JSON.parse(sessionStorage.getItem('token'))
      axios({ method: 'GET',
        'url': `${ENV.server_back}/api/hobject_types`,
        'data': '',
        'headers': {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': this.token.token_type + ' ' + this.token.access_token
        } }).then(result => {
        this.hObjectTypes = result.data
      }, error => {
        // console.error(error)
      })
    },
    fetchHObjectTags () {
      this.token = JSON.parse(sessionStorage.getItem('token'))
      axios({ method: 'GET',
        'url': `${ENV.server_back}/api/hobject_tags`,
        'data': '',
        'headers': {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': this.token.token_type + ' ' + this.token.access_token
        } }).then(result => {
        this.hObjectTags = result.data
      }, error => {
        // console.error(error)
      })
    },
    getUrlHObjectTypeImage (filename) {
      return this.urlBackImages + filename
    },
    tagStyle (color, textColor) {
      return `background-color: ${color}; color:${textColor};`
    },
    new_hObject (hObjectType, price) {
      let newhObjectName = this.newhObjectName
      EventBus.$emit('newHObjectTypeEvent', {newhObjectName, hObjectType, price})
      // Reset Form new hObject
      this.newhObjectName = ''
    }
  }
}
</script>

<style>

.modal-xl {
  max-width: 90% !important;
}

.modal-xl .card-footer {
    padding: 0.2rem 0.25rem 0.2rem 1.25rem;
}

.cardhObject {
  width: 250px;
  height: 400px;
  float: left;
  margin: 1%;
}

.pull-right {
    float: right !important;
}

</style>



// WEBPACK FOOTER //
// src/views/Editor/NewHObject.vue